import FlowerView from '@/views/flower';

export default [
  { path: '/', component: FlowerView, name: 'flower' },
  { path: '*', redirect: '/' },
];
